module.exports = __webpack_public_path__ + "img/bg-assign-popup-icon.f1722280.svg";